export default function Footer() {
    const footerLinks = document.querySelectorAll('.footer__top-link-list .footer__sub-link-toggle');

    footerLinks.forEach(link => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            const minus = link.querySelector('.footer__icon-minus');
            const plus = link.querySelector('.footer__icon-plus');
            const subLinkList = link.nextElementSibling;

            minus.classList.toggle('h-hidden');
            plus.classList.toggle('h-hidden');
            subLinkList.classList.toggle('h-hidden-from-view');

            const isExpanded = link.getAttribute('aria-expanded') === 'true';
            link.setAttribute('aria-expanded', String(!isExpanded));
        });
    });
}
